import { Children, cloneElement, isValidElement, ReactNode } from "react";

import Box from "../Box/Box";
import Step from "./Step";
import SubTask from "./SubTask";

interface VerticalTimelineProps {
  children: ReactNode;
}

const VerticalTimeline = ({ children }: VerticalTimelineProps) => {
  const numberOfChildren = Children.count(children);
  const childrenWithProps = Children.map(children, (child, index) => {
    return (
      isValidElement(child) &&
      cloneElement(child, {
        isLast: index === numberOfChildren - 1,
      })
    );
  });

  return (
    <Box display="flex" flexDirection="column">
      {childrenWithProps}
    </Box>
  );
};

VerticalTimeline.Step = Step;
VerticalTimeline.SubTask = SubTask;

export default VerticalTimeline;
